import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { fromConsultant } from '../reducers/consultant.reducer';
import { map } from 'rxjs/operators';
import { UtilsService } from '../services/utils.service';
import { AuthenticationService } from '../services/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class InternalGuard implements CanActivate {

  constructor(
    private router: Router,
    private store: Store,
    private authenticationService: AuthenticationService) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkPermission(route);
  }

  private checkPermission<Boolean>(route: ActivatedRouteSnapshot) {

    switch (route.routeConfig.path) {
      case '':
        const candidate = JSON.parse(localStorage.getItem('candidate'));
        // si existen datos de un candidato logarlo le llevamos a su home
        if (candidate) {
          this.router.navigate(['candidate/home', candidate.invitations[0].token]);
          return false;
          // si no existen datos de candidato logado limpiamos sesion y llevamos a login de consultor
        } else {
          this.authenticationService.logOut('consultant');
          return false;
        }
        break;

      default:
        return this.store.pipe(select(fromConsultant.selectConsultantState)).pipe(map(consultant => {
          if (consultant?.token) {
            return true;
          } else {
            this.authenticationService.logOut('consultant');
            return false;
          }
        }));
    }
  }
}
